import {
  Action_GetCauHinhJS,
  Action_GetCauHinhJSSuccess,
  Action_SaveLichSuView,
  Action_SaveLichSuViewSuccess,
  Action_GetLichSuView,
  Action_GetLichSuViewSuccess
} from "./actionTypes";

// Sự kiện lưu 
export const Index_GetCauHinhJS = (data) => ({
  type: Action_GetCauHinhJS,
  payload: data
});
export const Index_GetCauHinhJSSuccess = (data) => ({
  type: Action_GetCauHinhJSSuccess,
  payload: data,
});
//////////////////////////
export const Index_SaveLichSuView = (data) => ({
  type: Action_SaveLichSuView,
  payload: data
});
export const Index_SaveLichSuViewSuccess = (data) => ({
  type: Action_SaveLichSuViewSuccess,
  payload: data,
});
////////////////////////////////////////
export const Index_GetLichSuView = (data) => ({
  type: Action_GetLichSuView,
  payload: data
});
export const Index_GetLichSuViewSuccess = (data) => ({
  type: Action_GetLichSuViewSuccess,
  payload: data,
});
